import {FC, HTMLAttributes} from 'react'

export const PowerIcon: FC<{size?: number; fill?: string} & HTMLAttributes<SVGSVGElement>> = ({
    size = 20,
    fill = '#D92D20',
    ...rest
}) => {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" {...rest}>
            <path
                d="M10 1.66602V9.99935M15.3 5.53268C16.3487 6.58167 17.0627 7.91805 17.3519 9.37284C17.6411 10.8276 17.4924 12.3355 16.9247 13.7058C16.357 15.0761 15.3957 16.2473 14.1624 17.0713C12.9291 17.8953 11.4791 18.3351 9.99585 18.3351C8.5126 18.3351 7.06265 17.8953 5.82933 17.0713C4.59602 16.2473 3.63472 15.0761 3.06699 13.7058C2.49926 12.3355 2.35059 10.8276 2.63978 9.37284C2.92897 7.91805 3.64304 6.58167 4.69169 5.53268"
                stroke={fill}
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
